import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-premio-mobilidade {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: #F0F0F0;
}
.carros-eletricos-premio-mobilidade-img {
  width: 256px;
  height: 169px;
  box-shadow: 39px -31px 0px 0px #cc0000;
  margin: 40px auto 0;
  object-fit: cover;
  border-radius: 4px;
  display: flex;
}
.carros-eletricos-premio-mobilidade-titulo {
  color: #cc0000;
  font-family: "SantanderHeadline";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px
}
.carros-eletricos-premio-mobilidade-texto {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
.btn-premio-saiba-mais {
  width: 232px;
  height: 48px;
  font-family: "SantanderText";
  font-size: 18px;
  margin: 25px auto 0;
}
.premio-regulamento {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; 
  text-decoration-line: underline;
  margin: 24px auto 25px;
  width: 232px;
  display: flex;
}
.carros-eletricos-premio-mobilidade-logo-desk {
  display: none;
}

@media (min-width: 992px) {
  .carros-eletricos-premio-mobilidade-logo {
    display: none;
  }
  #carros-eletricos-premio-mobilidade {
    background-color: #FBFBFB;
    padding-bottom: 56px;
  }
  #carros-eletricos-premio-mobilidade .ctn {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .carros-eletricos-premio-mobilidade-logo-desk {
    display: block;
    width: 227px;
    height: 119px;
    object-fit: cover;
  }
  .carros-eletricos-premio-mobilidade-img {
    width: 637px;
    height: 424px;
    margin-right: -82px;
  }
  .carros-eletricos-premio-mobilidade-titulo {
    font-size: 24px;
    line-height: 36px;
    max-width: 446px;
    margin: 32px 0 0;
  }
  .carros-eletricos-premio-mobilidade-texto {
    font-size: 18px;
    line-height: 28px;
    margin: 24px 0 0;
    max-width: 446px;
  }
  .btn-premio-saiba-mais {
   margin: 40px 0 0 ;
  }
  .premio-regulamento {
    margin: 24px 0 0 ;
  }
}`;

export default styles;